import "@/styles/globals.css"
import type { AppProps } from "next/app"
import { Toaster } from "sonner"

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            backdropFilter:
              "blur(6px) saturate(190%) contrast(50%) brightness(130%)",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            border: "0.5px solid rgb(216, 216, 216)",
            boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
          },
        }}
      />
      <Component {...pageProps} />
    </>
  )
}
